import { render, staticRenderFns } from "./AdminEditReservation.vue?vue&type=template&id=16d2e06f&scoped=true&"
import script from "./AdminEditReservation.vue?vue&type=script&lang=js&"
export * from "./AdminEditReservation.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditReservation.vue?vue&type=style&index=0&id=16d2e06f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2e06f",
  null
  
)

export default component.exports